<script lang="ts" setup>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useCookie, useRoute } from 'nuxt/app'
import { EClickElement } from '@/cms-ui/utils/dataLayer'
import { VIconButtonVariants } from '@/ui/plushComponents/VIconButton/types'
import { useClickTracking } from '@/cms-ui/composables/useAnalytics'

defineProps({
    cart: {
        type: Object,
        required: true,
    },
    isDesktopMenuOpen: {
        type: Boolean,
        default: false,
    },
})

const isCartEmpty = ref(true)
const basketLinkCookie = useCookie('basketLink')
const localStorageInfo = ref<string | null>(null)
let intervalId: number | null = null
let previousValue: string | null = null

const checkLocalStorage = (): void => {
    if (process.client) {
        const currentValue = localStorage.getItem('basketData')

        if (currentValue !== previousValue) {
            previousValue = currentValue
            if (currentValue) localStorageInfo.value = JSON.parse(currentValue)
            console.log('Wartość w localStorage zmieniła się:', localStorageInfo.value)
        }
    }
}

// ESHOP-6425
watch(
    localStorageInfo,
    newValue => {
        localStorageInfo.value === null ? (isCartEmpty.value = true) : (isCartEmpty.value = false)
    },
    {
        immediate: true,
    },
)

watch(
    basketLinkCookie,
    () => {
        if (
            basketLinkCookie.value &&
            basketLinkCookie.value.includes('/shopping-flow/') &&
            basketLinkCookie.value !== '/shopping-flow/empty'
        ) {
            isCartEmpty.value = false
            return
        }
        isCartEmpty.value = true
    },
    {
        immediate: true,
    },
)

const basketLink = computed(() => {
    if (useRoute().path.startsWith('/dla-firm/')) {
        return `/dla-firm${basketLinkCookie.value}`
    }
    return basketLinkCookie.value || (localStorageInfo.value ? '/shopping-flow/step1-e' : '#')
})

const isBubbleVisible = ref(false)

function hideBubble(): void {
    isBubbleVisible.value = false
}

async function basketLinkHandler(): Promise<void> {
    if (isCartEmpty.value) {
        console.log('is isCartEmpty')
        isBubbleVisible.value = !isBubbleVisible.value
        return
    }

    console.log('wartości przed if')
    console.log(basketLinkCookie.value)
    console.log(localStorageInfo.value)
    console.log('wartości przed if')

    if (basketLinkCookie.value || localStorageInfo.value) {
        console.log('if cart is not empty')
        console.log(basketLinkCookie.value)
        console.log(localStorageInfo.value)
        useClickTracking({
            label: 'cart',
            clickPath: basketLink.value,
            clickElement: EClickElement.ICON,
            componentName: 'header',
            componentCategory: 'menu',
        })

        window.location.href = basketLink.value // can't use vue router in navigation between different apps
    }
}

onMounted(() => {
    checkLocalStorage()

    if (process.client) {
        intervalId = window.setInterval(checkLocalStorage, 1000) // Sprawdzaj co 500ms
        console.log('Polling localStorage uruchomiony')
    }

    if (process.client) {
        window.addEventListener('storage', event => {
            if (event.key === 'basketData') {
                localStorageInfo.value = event.newValue
                console.log('Zdarzenie storage wykryło zmianę:', event.newValue)
            }
        })
    }
})

onUnmounted(() => {
    if (process.client && intervalId !== null) {
        clearInterval(intervalId)
        intervalId = null
        console.log('Polling localStorage zatrzymany')
    }
})
</script>

<template>
    <HeaderPartsBubble
        :show="isBubbleVisible"
        @turn-off="hideBubble"
    >
        <template #trigger>
            <div class="relative">
                <VIconButton
                    icon="shopping-cart"
                    size="MEDIUM"
                    :variant="VIconButtonVariants.plain"
                    :dark="isDesktopMenuOpen"
                    data-test="header-cart"
                    @click="basketLinkHandler"
                />

                <span
                    v-if="!isCartEmpty"
                    class="bg-brand-highlight w-sm h-sm rounded-container-lg absolute right-2 top-0"
                />
            </div>
        </template>

        <template #title>
            <div v-html-gpp="cart.header" />
        </template>

        <template #content>
            <div
                v-html-gpp="cart.body.value"
                class="paragraph-md text-neutral-primary line-clamp-3"
            />
        </template>
    </HeaderPartsBubble>
</template>
